/** Walk nested `navPaths.paths` and return a string label, or `null` if missing. */
export function resolveNavPathMessage(
  paths: Record<string, unknown> | undefined,
  pathKey: string
): string | null {
  if (!paths || !pathKey) return null;

  const segments = pathKey.split('.').filter(Boolean);
  let node: unknown = paths;

  for (const segment of segments) {
    if (node == null || typeof node !== 'object' || Array.isArray(node)) return null;
    node = (node as Record<string, unknown>)[segment];
  }

  if (typeof node === 'string') return node;
  if (node && typeof node === 'object' && typeof (node as Record<string, unknown>).__ === 'string') {
    return (node as Record<string, unknown>).__ as string;
  }

  return null;
}
